var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marker",style:({
    width: _vm.width + 'px',
    height: _vm.anchor + 'px',
    margin: ("-" + _vm.anchor + "px 0 0 -" + (_vm.width/2) + "px"),
    fill: _vm.computedFill,
    color: _vm.computedColor,
    stroke: _vm.computedStroke
  })},[_c('svg',{attrs:{"viewBox":"0 0 155 200"}},[_c('use',{attrs:{"xlink:href":"#markerIcon"}})]),_c('div',{style:({
      width: _vm.width + 'px',
      height: _vm.width + 'px'
    })},[(_vm.type === 'img')?_c('q-img',{style:({
        width: _vm.iconSize + 'px',
        height: _vm.iconSize + 'px'
      }),attrs:{"src":_vm.icon}}):_c('q-icon',{attrs:{"name":_vm.icon,"size":_vm.iconSize + 'px'}})],1),(_vm.leftStatusStyle)?_c('div',{staticClass:"marker-status",style:(_vm.resultStyle('left', _vm.leftStatusStyle))},[_c('q-icon',{attrs:{"name":_vm.leftStatusStyle.icon,"size":_vm.width * 0.35 + 'px'}})],1):_vm._e(),(_vm.rightStatusStyle)?_c('div',{staticClass:"marker-status",style:(_vm.resultStyle('right', _vm.rightStatusStyle))},[_c('q-icon',{attrs:{"name":_vm.rightStatusStyle.icon,"size":_vm.width * 0.35 + 'px'}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }